module.exports = "../fonts/HelveticaNeueLTW01-65Medium.eot";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-65Medium.eot
// module id = BReQ
// module chunks = 1